import React, { useState } from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import { apiInchat } from 'api'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { toastMessage } from 'utils/messages'

const VideoCallButton = ({ conversationId, insertTextInComposer }) => {
  const [isLoadingJoinLink, setIsLoadingJoinLink] = useState(false)

  const onClickButtonJoin = () => {
    setIsLoadingJoinLink(!isLoadingJoinLink)

    apiInchat.createJoinLink({ conversationId })
      .then(({ data: { data } }) => {
        insertTextInComposer(data.url, false)
        navigator.clipboard.writeText(data.url)
        toastMessage(lang('dashboard_videocall-url-copied-clipboard'))
      })
      .catch(console.error)
      .finally(() => setIsLoadingJoinLink(false))
  }

  return (
    <div className='inchat-button-join' onClick={onClickButtonJoin} title={lang('Crear enlace para videollamada')}>
      {!isLoadingJoinLink ? (
        <figure>
          <img
            src={getStaticImage('/icons/orange-brand/icon-videocall-primary.svg')}
            alt={lang('dashboard_videocall')}
          />
        </figure>
      ) : (
        <Nixi1Spinner width='17px' height='17px' />
      )}
    </div>
  )
}

export default VideoCallButton
